export default function PressContact() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg p-12 border border-gray-200 text-center">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-line text-3xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Press Inquiries
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            For media inquiries, interview requests, or additional information about TrackVerse, 
            please contact our press team.
          </p>
          
          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-center gap-3">
              <i className="ri-mail-line text-xl text-blue-600"></i>
              <a href="mailto:info.trackverse@gmail.com" className="text-lg text-blue-600 hover:text-blue-700 font-medium">
                info.trackverse@gmail.com
              </a>
            </div>
            <div className="flex items-center justify-center gap-3">
              <i className="ri-map-pin-line text-xl text-green-600"></i>
              <span className="text-gray-600">
                Building F, 18 Boulevard Tino Rossi, 20000 Ajaccio
              </span>
            </div>
            <div className="flex items-center justify-center gap-3">
              <i className="ri-time-line text-xl text-blue-600"></i>
              <span className="text-gray-600">
                Monday - Saturday, 8:00 AM - 7:00 PM
              </span>
            </div>
          </div>

          <button className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-mail-send-line"></i>
            Contact Press Team
          </button>
        </div>
      </div>
    </section>
  );
}
